import FirebaseConfig from "../firebaseConfig";

export  function signIn(email , password,callback){
    FirebaseConfig.auth().signInWithEmailAndPassword(email , password).then((user) => {
      callback(user,true)
    })
    .catch((error) => {
      callback({},false)
      // var errorCode = error.code;
      // var errorMessage = error.message;
    });;
  };

  export function logOut(callback){
    FirebaseConfig.auth().signOut().then(()=>{
      callback(true)
    }).catch((error) => {
      callback(false)
    })
  }

  